// extracted by mini-css-extract-plugin
export var content = "_4a-3";
export var list = "_4a-4";
export var settingsContent = "_4a-7";
export var settingsPanel = "_4a-8";
export var state = "_4a-6";
export var triggerBadge = "_4a-2";
export var triggerButton = "_4a-1";
export var triggerShell = "_4a-0";
export var unreadDot = "_4a-5";